"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionProviderHelpers = void 0;
class CollectionProviderHelpers {
    static isCollectionProvider(c) {
        return typeof c.getCollections === 'function';
    }
    static getCollections(c) {
        const collections = [];
        c.forEachField((field) => {
            if (!CollectionProviderHelpers.isCollectionProvider(field)) {
                return;
            }
            const fieldCaptures = field.getCollections() || [];
            for (const fieldCapture of fieldCaptures) {
                collections.push(fieldCapture);
            }
        });
        return collections;
    }
    static getCollectionIds(c) {
        const collections = [];
        c.forEachField((field) => {
            if (!CollectionProviderHelpers.isCollectionProvider(field)) {
                return;
            }
            const fieldCaptures = field.getCollectionIds() || [];
            for (const fieldCapture of fieldCaptures) {
                collections.push(fieldCapture);
            }
        });
        return collections;
    }
}
exports.CollectionProviderHelpers = CollectionProviderHelpers;
//# sourceMappingURL=collection.provider.js.map